import { useCallback } from 'react'
import api from '../../lib/commons/api'
import {
  TaskActualWorkApproveRepository,
  TaskActualWorkApproveUserDto,
} from '../../applications/ports/taskActualWorkApproveRepository'

export const useTaskActualWorkApproveRepository =
  (): TaskActualWorkApproveRepository => {
    const fetchProjectMembersForApproval = useCallback(
      async (date?: string): Promise<TaskActualWorkApproveUserDto[]> => {
        const response = await api.functional.request(
          'GET',
          '/api/v1/projects/members/valid',
          { date },
          true
        )
        return response.json as TaskActualWorkApproveUserDto[]
      },
      []
    )

    return {
      fetchProjectMembersForApproval,
    }
  }
